//=====================================================
//　共通関数
//=====================================================

//-----------------------------------------------------
//　数値のゼロパディング整形
//  target：数値
//  digit：パディング桁数
//-----------------------------------------------------
export function zeroPadding(target: number, digit: number){
    return (Array(digit).join('0') + target).slice(-digit);
}

//-----------------------------------------------------
//　日付のフォーマット整形
//  fromTimeMark：「～」を表示するか
//-----------------------------------------------------
export function formatDate(val: Date, fromTimeMark: boolean){
    let dateUnfixed = new Date(1900, 0, 1, 0, 0, 0, 0);

    if(dateUnfixed.valueOf() === val.valueOf()){
        return "日時未決定";
    }else{
        //「～」の表示
        let mark = "";
        if (fromTimeMark){
            mark = "～";
        }

        //曜日の変換
        const weeks:string[] = ["日", "月", "火", "水", "木", "金", "土"];

        return val.getFullYear() + "年" + zeroPadding(val.getMonth() + 1, 2) + "月" + zeroPadding(val.getDate(), 2) + "日" 
            + "(" + weeks[val.getDay()] + ") " + zeroPadding(val.getHours(), 2) + ":" + zeroPadding(val.getMinutes(), 2) + mark;
    }
}
//-----------------------------------------------------
//　文字列を日付に整形
//  yyyy年mm月dd日(曜日) hh:mm から
//  yyyy/mm/dd hh:mm に整形
//-----------------------------------------------------
export function formatString(date: String){

    //曜日を除去し、日付型に整形
    const tmpYear = date.split("年")[0];
    const tmpMoth = date.split("年")[1].split("月")[0];
    const tmpDay = date.split("年")[1].split("月")[1].split("日")[0]
    const tmpTime = date.split(" ")[1]

    return new Date(tmpYear + "/" + tmpMoth + "/" + tmpDay + " " + tmpTime);

}

//-----------------------------------------------------
//　日付を文字列に整形
//  Date型の値 から
//  yyyy/mm/dd hh:mmの文字列に整形
//-----------------------------------------------------
export function formatDateTime(val: Date){

    return val.getFullYear() + "/" + (val.getMonth() + 1)  + "/" + val.getDate() 
        + " " + val.getHours() + ":" + ("00" + val.getMinutes()).slice(-2);

}

//----------------------------------------------------
//日付を整形
//
//YYYYMMの文字列に整形
//-----------------------------------------------------
export function formatDateMonth(val: Date){

    var getFullYear = val.getFullYear();
    var getMonth    = ("0"+(val.getMonth() + 1)).slice(-2);
    
    return getFullYear + getMonth;
}

//----------------------------------------------------
//日付を整形
//
//YYYYMMDDの文字列に整形
//-----------------------------------------------------
export function formatDateWeek(val: Date){
    var getFullYear = val.getFullYear();
    var getMonth    = ("0"+(val.getMonth() + 1)).slice(-2);
    var getDate     = ("0"+val.getDate()).slice(-2);
    
    return getFullYear + getMonth + getDate;
    
}